import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import moment from "moment";
import { encode } from "base-64";
import { store } from "../../store";
import { clearAllCookies, PushResetApp } from "../../utils/sign-out";

const instance = axios.create({
  withCredentials: true,
});

instance.interceptors.request.use((config) => {
  if (!config?.headers) {
    throw new Error(
      `Expected 'config' and 'config.headers' not to be undefined`
    );
  }
  const accessToken = ""; //getUserToken(); TODO
  let correlationAppContext = [
    {
      ApplicationName: "",
      CNameOrAzureAppName: window.location.href,
      TimeStamp: moment(),
    },
  ];
  config.headers["correlation-app-context"] = encode(
    JSON.stringify(correlationAppContext)
  );
  config.headers["Content-Type"] = "application/json";
  if (accessToken) {
    config.headers["Authorization"] = `Bearer ${accessToken}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => {
    return response?.data ?? response;
  },
  (error) => {
    const status = error?.response?.status;
    if (Number(status) === Number(401)) {
      localStorage.removeItem("expiresAt");
      localStorage.removeItem("gender");
      localStorage.removeItem("userAnswers");

      // Clear all cookies
      clearAllCookies();
      // Reset Redux store
      store.dispatch(PushResetApp());
    }

    return Promise.reject(error); // 🔴 VERY IMPORTANT
  }

  // const expiresAt = !!localStorage.getItem("expiresAt") ? moment(localStorage.getItem("expiresAt")) : "";
  // const currentDate = moment(new Date().toUTCString());
  // if (expiresAt != "" && expiresAt.isBefore(currentDate)) {
  //   const locale = !!localStorage.getItem("i18nextLng") ? localStorage.getItem("i18nextLng") : "";
  //   if (locale != "") {
  //     window.location.href = ROUTE_CONSTANT.SESSION_EXPIRE_LOCALE.replace(":locale", locale);
  //   } else {
  //     window.location.href = ROUTE_CONSTANT.SESSION_EXPIRE;
  //   }
  // } else if (response.data) {
  //   return response.data;
  // }
);

const apiService = {
  get: (url, data, headers, withCredentials) => {
    const config = { params: {}, headers: {} };
    if (!url) {
      throw Error("endPoint is required params");
    } else {
      if (data) {
        config.params = data;
      }
      if (headers) {
        config.headers = headers;
      }
      if (withCredentials) {
        config.withCredentials = true;
      }
      return instance.get(url, config);
    }
  },
  post: (url, data, headers) => {
    if (!url || !data) {
      throw Error("endPoint and data are required params");
    }
    return instance.post(url, data, { headers });
  },
  put: (url, data, headers) => {
    if (!url || !data) {
      throw Error("endpoint and data are required params");
    }
    return instance.put(url, data, { headers });
  },
  patch: (url, data, headers) => {
    if (!url || !data) {
      throw Error("endpoint and data are required params");
    }
    return instance.patch(url, data, { headers });
  },
  delete: (url, data, headers) => {
    if (!url || !data) {
      throw Error("endPoint and data are required params");
    }
    return instance.delete(url, { data, headers });
  },
};

export { apiService };
